var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":"items.label","bread-crumb-data":_vm.breadCrumbData}},[_c('items-table',{attrs:{"page-data-id":"items"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }